//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Placeholder from "../Dashboard/Widgets/Placeholder";
import Timer from 'src/store/models/Timer';
import TimerDetail from 'src/components/Entries/Entity';
import { findIndex } from 'lodash';
import moment from 'moment';
export default {
  components: {
    TimerDetail: TimerDetail,
    Placeholder: Placeholder
  },
  data: function data() {
    var _this = this;

    return {
      placeholder: {
        img: 'timers_empty_state',
        text: this.$t('components.timers.dont_have_active_or_paused_timers'),
        button: this.$t('general.start_tracking_time'),
        icon: 'add',
        action: function action() {
          _this.openDialog('RegisterTimeDialog');
        }
      }
    };
  },
  props: ['isPage'],
  computed: {
    timers: function timers() {
      return Timer.query().where('user_id', this.me.user_id).with(['project', 'user', 'user.avatar', 'phase', 'tags.tag_list']).get();
    },
    timersByDate: function timersByDate() {
      var _this2 = this;

      var timersByDate = []; //

      this.timers.forEach(function (timer) {
        var dateIndex = findIndex(timersByDate, ['date', timer.timer_date]);

        if (dateIndex === -1) {
          timersByDate.push({
            timers: [],
            date: timer.timer_date,
            totalTime: 0
          });
          dateIndex = timersByDate.length - 1;
        }

        timersByDate[dateIndex].timers.push(timer);
        timersByDate[dateIndex].totalTime += _this2.entityMinutes(timer);
      });
      return timersByDate;
    }
  },
  methods: {
    isRunning: function isRunning(timer) {
      return timer.timer_status === 'running';
    },
    entityMinutes: function entityMinutes(timer) {
      var seconds = this.isRunning(timer) ? timer.seconds + moment.utc().diff(moment.utc(timer.timer_start), this.$t('general.seconds')) : timer.seconds;
      return parseInt(seconds / 60);
    }
  }
};